module.exports = __webpack_public_path__ + "static/media/03.59589d2c.png";